module.exports = __webpack_public_path__ + "img/kaiqui2.b025b9f4.png";